/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialog_Not_Enough_Gems_DescriptionInputs */

const en_dialog_not_enough_gems_description = /** @type {(inputs: Dialog_Not_Enough_Gems_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Earn more through Focus Challenge, or get more at the Shop.`)
};

const ar_dialog_not_enough_gems_description = /** @type {(inputs: Dialog_Not_Enough_Gems_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اكسب المزيد من تحديات التركيز، أو احصل على المزيد من المتجر.`)
};

const de_dialog_not_enough_gems_description = /** @type {(inputs: Dialog_Not_Enough_Gems_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verdiene mehr durch Fokus Herausforderungen oder hol dir mehr im Shop.`)
};

const es_dialog_not_enough_gems_description = /** @type {(inputs: Dialog_Not_Enough_Gems_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gana más con los Desafíos de concentración, o consigue más en la Tienda.`)
};

const fr_dialog_not_enough_gems_description = /** @type {(inputs: Dialog_Not_Enough_Gems_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gagnes-en plus grâce au Défi de Concentration, ou obtiens-en plus dans la boutique.`)
};

const it_dialog_not_enough_gems_description = /** @type {(inputs: Dialog_Not_Enough_Gems_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guadagna di più con la Sfida di Concentrazione, o ottienine di più nel Negozio.`)
};

const ja_dialog_not_enough_gems_description = /** @type {(inputs: Dialog_Not_Enough_Gems_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`集中チャレンジでもっと獲得するか、ストアで手に入れましょう。`)
};

const ko_dialog_not_enough_gems_description = /** @type {(inputs: Dialog_Not_Enough_Gems_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`집중 챌린지로 더 모으거나, 상점에서 채우세요.`)
};

const pt_br_dialog_not_enough_gems_description = /** @type {(inputs: Dialog_Not_Enough_Gems_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ganhe mais no Desafio de Foco, ou consiga mais na Loja.`)
};

const ru_dialog_not_enough_gems_description = /** @type {(inputs: Dialog_Not_Enough_Gems_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Зарабатывай больше в Задании по фокусировке или получи ещё в магазине.`)
};

const th_dialog_not_enough_gems_description = /** @type {(inputs: Dialog_Not_Enough_Gems_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`รับเพิ่มจากความท้าทายการโฟกัส หรือไปรับเพิ่มที่ร้านค้า`)
};

const tr_dialog_not_enough_gems_description = /** @type {(inputs: Dialog_Not_Enough_Gems_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Odaklanma Mücadeleleriyle daha fazla kazan ya da Mağazadan daha fazlasını al.`)
};

const zh_cn_dialog_not_enough_gems_description = /** @type {(inputs: Dialog_Not_Enough_Gems_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`参加专注挑战就能获得更多，或到商店补充。`)
};

const zh_tw_dialog_not_enough_gems_description = /** @type {(inputs: Dialog_Not_Enough_Gems_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`參加專注挑戰就能獲得更多，或到商店補充。`)
};

/**
* | output |
* | --- |
* | "Earn more through Focus Challenge, or get more at the Shop." |
*
* @param {Dialog_Not_Enough_Gems_DescriptionInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const dialog_not_enough_gems_description = /** @type {((inputs?: Dialog_Not_Enough_Gems_DescriptionInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Not_Enough_Gems_DescriptionInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dialog_not_enough_gems_description(inputs)
	if (locale === "ar") return ar_dialog_not_enough_gems_description(inputs)
	if (locale === "de") return de_dialog_not_enough_gems_description(inputs)
	if (locale === "es") return es_dialog_not_enough_gems_description(inputs)
	if (locale === "fr") return fr_dialog_not_enough_gems_description(inputs)
	if (locale === "it") return it_dialog_not_enough_gems_description(inputs)
	if (locale === "ja") return ja_dialog_not_enough_gems_description(inputs)
	if (locale === "ko") return ko_dialog_not_enough_gems_description(inputs)
	if (locale === "pt_br") return pt_br_dialog_not_enough_gems_description(inputs)
	if (locale === "ru") return ru_dialog_not_enough_gems_description(inputs)
	if (locale === "th") return th_dialog_not_enough_gems_description(inputs)
	if (locale === "tr") return tr_dialog_not_enough_gems_description(inputs)
	if (locale === "zh_cn") return zh_cn_dialog_not_enough_gems_description(inputs)
	return zh_tw_dialog_not_enough_gems_description(inputs)
});